var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgFinancialReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1667 18.6667H2.83333C2.61232 18.6667 2.40036 18.5789 2.24408 18.4226C2.0878 18.2663 2 18.0543 2 17.8333V2.83333C2 2.61232 2.0878 2.40036 2.24408 2.24408C2.40036 2.0878 2.61232 2 2.83333 2H16.1667C16.3877 2 16.5996 2.0878 16.7559 2.24408C16.9122 2.40036 17 2.61232 17 2.83333V17.8333C17 18.0543 16.9122 18.2663 16.7559 18.4226C16.5996 18.5789 16.3877 18.6667 16.1667 18.6667ZM15.3333 17V3.66667H3.66667V17H15.3333ZM6.16667 7.83333H12.8333V9.5H6.16667V7.83333ZM6.16667 11.1667H12.8333V12.8333H6.16667V11.1667Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialReport);
export default __webpack_public_path__ + "static/media/financialReport.285cbf1c23219d5e90dcea4e290f5ed1.svg";
export { ForwardRef as ReactComponent };